var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoundArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "head",
    orient: "auto",
    markerWidth: 4,
    markerHeight: 4,
    refX: 0.1,
    refY: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 V4 L4,2 Z",
    fill: "#d2d2d2"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow1",
    refX: 0,
    refY: 1.8,
    markerUnits: "strokeWidth",
    markerWidth: 10,
    markerHeight: 10,
    orient: "auto",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,4 L6,2 z",
    stroke: "#d2d2d2",
    fill: "#d2d2d2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "black",
    fillRule: "evenodd",
    stroke: "#d2d2d2",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 20,
    x2: 26,
    y2: 20,
    stroke: "#d2d2d2",
    strokeWidth: 4,
    markerEnd: "url(#head)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 20  h-2   a10 10 0 0 1 -10 -10 v-40",
    stroke: "#d2d2d2",
    strokeWidth: 4,
    fill: "transparent"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoundArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/roundArrow.8793fe37d24c72aea77249554e72532d.svg";